import { AdditionalChecks } from './AdditionalChecks';
import { SelectionCombination } from '../../../components/SelectedCombination';
import styles from './styles.module.css';
import React, { useEffect, useState } from 'react';
import { Info } from './Info';
import SelectionMenuBase from '../../../components/SelectionMenuBase/SelectionMenuBase';
import { Icons } from '../../../components/Icon/Icon';
import AsideMenuSelectionMenuGroup, {
    asideMenuSelectionMenuGroups,
} from '../../../components/AsideMenuSelection/AsideMenuSelectionMenuGroup';

const LegalStructureSelection = ({ handleCheckbox, selectedData, onEdit, active, setActive, hidden }: any) => {
    const [openCategory, setOpenCategory] = useState<undefined | string>(asideMenuSelectionMenuGroups.selection);
    const [contentHeight, setcontentHeight] = useState(900);

    useEffect(() => {
        setcontentHeight(570 + 80 * selectedData.investors.length + 20 * selectedData.assets.length);
    }, [selectedData]);

    const toggleCategory = (category: any) => {
        setOpenCategory(openCategory === category ? undefined : category);
    };

    // const handleSelectedInvestor = (id: number) => () => {
    //     setSelectedInvestor(selectedData.investors.find((investor: SelectedItem) => investor.id === id));
    // };

    return (
        <>
            <SelectionMenuBase info={<Info />} active={active} setActive={setActive} hidden={hidden}>
                <div className={styles.mainInfo}>
                    <AsideMenuSelectionMenuGroup
                        icon={Icons.chevronDownFilled}
                        label={'Initial inputs'}
                        setOpenCategory={toggleCategory}
                        openCategory={openCategory}
                        category={asideMenuSelectionMenuGroups.selection}
                        contentHeight={contentHeight}
                        onEdit={onEdit}
                    >
                        <SelectionCombination selectedData={selectedData} isOptimisation={false} hideFundRow={true} />
                    </AsideMenuSelectionMenuGroup>

                    <AsideMenuSelectionMenuGroup
                        icon={Icons.chevronDownFilled}
                        label={'Further selection'}
                        setOpenCategory={toggleCategory}
                        openCategory={openCategory}
                        category={asideMenuSelectionMenuGroups.checkboxes}
                        contentHeight={contentHeight}
                    >
                        <AdditionalChecks handleCheckbox={handleCheckbox} selectedData={selectedData} />
                    </AsideMenuSelectionMenuGroup>
                </div>
            </SelectionMenuBase>

            {/*<div>*/}
            {/*    <TransitionComponent inProp={!active} duration={100}>*/}
            {/*        <p className={styles.graphTip}>*/}
            {/*            /!*{comments ? `${comments.legendId} : ${comments.fullComments}` : ''}*!/*/}
            {/*            {legends*/}
            {/*                ? legends.map((l, i) => (*/}
            {/*                      <React.Fragment key={i}>*/}
            {/*                          {l} <br />*/}
            {/*                      </React.Fragment>*/}
            {/*                  ))*/}
            {/*                : ''}*/}
            {/*        </p>*/}
            {/*    </TransitionComponent>*/}
            {/*</div>*/}
        </>
    );
};

export default LegalStructureSelection;
